import { useEffect, useRef, useState } from 'react';
import { ChevronDownLine, ChevronUpLine } from '@poli-ink/react';
import { Button } from '@polichat/flamboyant';
export function TranscriptionText({ text }: Readonly<{ text: string }>) {
  const [expanded, setExpanded] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);
  const [showArrow, setShowArrow] = useState(false);

  useEffect(() => {
    if (textRef.current) {
      const height = textRef.current.scrollHeight;
      setShowArrow(height > 50);
    }
  }, [text]);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: '8px',
        maxWidth: '277px',
        position: 'relative',
      }}
    >
      <div
        ref={textRef}
        style={{
          flex: 1,
          marginBottom: '0.5rem',
          fontWeight: '300',
          fontStyle: 'italic',
          fontSize: '12px',
          lineHeight: '100%',
          maxHeight: expanded ? 'none' : '50px',
          overflow: 'hidden',
          textOverflow: expanded ? 'clip' : 'ellipsis',
        }}
      >
        <p>{text}</p>
      </div>
      {showArrow && (
        <Button
          color="transparent"
          onClick={() => setExpanded((prev) => !prev)}
          style={{
            position: 'absolute',
            right: 0,
            top: expanded ? 'auto' : 0,
            bottom: expanded ? 0 : 'auto',
          }}
        >
          {expanded ? (
            <ChevronUpLine color={'var(--primary)'} width="16" height="16" />
          ) : (
            <ChevronDownLine color={'var(--primary)'} width="16" height="16" />
          )}
        </Button>
      )}
    </div>
  );
}
